import { apiClient } from "../client";

export interface PortfolioMetricsRequest {
  startDate: string;
  endDate: string;
  profileIds: string[];
  country?: string;
  /**
   * Optional; when omitted or an empty array, the API should
   * return metrics for all portfolios.
   */
  portfolioIds?: string[];
}

// Row-level metrics for each portfolio, matching backend response
export interface PortfolioMetricsRow {
  portfolio_id: string;
  portfolio_name: string | null;
  profile_ids: string[];
  impressions: number;
  clicks: number;
  sales: number;
  orders: number;
  spend: number;
  ctr: number; // already percentage (e.g. 9.59 means 9.59%)
  acos: number; // percentage
  cvr: number; // percentage
}

export interface PortfolioMetricsResponse {
  success: boolean;
  total_count: number;
  data: PortfolioMetricsRow[];
}

export const portfolioMetricsService = {
  fetchMetrics: async (
    body: PortfolioMetricsRequest
  ): Promise<PortfolioMetricsResponse> => {
    const { data } = await apiClient.post("/portfolio/metrics", body);
    return data;
  },
};

